import { useEffect } from "react";
import { useAuth } from "../../features/auth/hooks/use-auth";

export const LogoutPage = () => {
  const { logout, isAuthenticated } = useAuth();
  useEffect(() => {
    if (isAuthenticated) {
      logout();
    } else {
      document.location.href = "/";
    }
  }, []);
  return <></>;
};
